import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const AddIcon = props => {
  return (
    <Svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M4.007 9a.75.75 0 01.75-.75H8.25V4.757a.75.75 0 111.5 0V8.25h3.492a.75.75 0 010 1.5H9.75v3.493a.75.75 0 11-1.5 0V9.75H4.757a.75.75 0 01-.75-.75z"
        fill="#3876AA"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.316.769a42.502 42.502 0 019.367 0c1.826.204 3.301 1.643 3.516 3.48.37 3.156.37 6.346 0 9.503-.215 1.836-1.69 3.275-3.516 3.48a42.512 42.512 0 01-9.367 0c-1.826-.205-3.3-1.643-3.516-3.48a40.902 40.902 0 010-9.504C1.015 2.412 2.49.973 4.316.768zm9.2 1.49a41.001 41.001 0 00-9.033 0A2.486 2.486 0 002.29 4.423a39.401 39.401 0 000 9.154 2.486 2.486 0 002.193 2.164c2.977.332 6.057.332 9.033 0a2.486 2.486 0 002.193-2.164 39.401 39.401 0 000-9.154 2.486 2.486 0 00-2.193-2.164z"
        fill="#3876AA"
      />
    </Svg>
  );
};

export default AddIcon;
